export const PUSH_PAYMENTS = {
    PARTNERS: {
        COLLECTION: {
            url: '/pushPayment/providers',
            queryKey: 'partners'
        }
    },
    NOTIF_RULES: {
        COLLECTION: {
            url: '/pushPayment/rules',
            queryKey: 'rules'
        },
        UPDATE_LABEL: {
            url: '/pushPayment/rules/:pushPaymentNotifRuleId'
        },
        DELETE_RULE: {
            url: '/pushPayment/rules/:pushPaymentNotifRuleId'
        },
        FILE_ACTION: {
            url: '/pushPayment/rules/fileAction'
        },
        EXPORT: {
            url: '/pushPayment/rules/export'
        }
    }
};